import {JsonObject, JsonProperty} from "json2typescript";

import {Dayjs} from "../../utils/dayjs";
import {DateTimeConverter, JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("DocumentRevisionPublishInput")
export class DocumentRevisionPublishInput {
    @JsonProperty("appliedAt", DateTimeConverter)
    public appliedAt: Dayjs = JsonPropertyEmpty;

    public constructor(args?: Partial<DocumentRevisionPublishInput>) {
        Object.assign(this, args);
    }
}
